import { ChangeEvent, FC, useState } from "react";
import { FieldRenderProps } from "react-final-form";
import { IconTooltip, TooltipIcons } from "../iconTooltip";
import classes from "./Textarea.module.scss";

interface Props extends Partial<FieldRenderProps<any, any>> {
  label?: string;
  style?: React.CSSProperties;
  tooltipIcon?: TooltipIcons;
  tooltipData?: string;
  rows?: number;
  id?: string | null;
  className?: string;
  placeholder?: string;
}

export const Textarea: FC<Props> = ({
  label,
  style,
  tooltipIcon,
  tooltipData,
  rows = 3,
  id,
  className = "",
  placeholder = "",
  ...rest
}) => {
  const idAttr = id ?? `textbox_${label}`;
  const [value, setValue] = useState("");

  function handleChange(e: ChangeEvent<HTMLTextAreaElement>) {
    setValue(e.target.value);
  }

  return (
    <div
      className={classes["input-container"] + classes[className]}
      style={style}
    >
      <label className={value && classes.filled} htmlFor={idAttr}>
        {label}
      </label>
      <textarea
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        rows={rows}
        id={idAttr}
        {...rest}
      />
      <div className={classes.tooltip}>
        {tooltipData && <IconTooltip data={tooltipData} icon={tooltipIcon} />}
      </div>
    </div>
  );
};

Textarea.defaultProps = {
  label: "",
  style: undefined,
  tooltipIcon: undefined,
  tooltipData: "",
  rows: 5,
  id: "",
  className: "",
  placeholder: "",
};
